import React from "react";
import { Box, Typography, Divider } from "@material-ui/core";
// direct import
import "../style.scss";

const AccountInfo = () => {
  return (
    <Box className="summary-renewal__card account-info">
      <Typography variant="h6" className="account-info__title">
        Validate Account Admin Info
      </Typography>

      <Box className="account-info__row">
        <Box>
          <Typography className="account-info__label">Email</Typography>
          <Typography className="account-info__value">
            barbs@gmail.com
          </Typography>
        </Box>
      </Box>
      <Divider className="account-info__divider" />

      <Box className="account-info__row">
        <Box>
          <Typography className="account-info__label">Address</Typography>
          <Typography className="account-info__value">
            123 Central Park South New York, NY 10019
          </Typography>
        </Box>
      </Box>
      <Divider className="account-info__divider" />

      <Box className="account-info__row">
        <Box>
          <Typography className="account-info__label">Mobile Phone</Typography>
          <Typography className="account-info__value">
            (917) 110-3876
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default AccountInfo;
